import React, { useContext, useEffect, useState } from "react";
import { CanvasContext } from "../../../contexts/CanvasContext";

const ListComponent = ({ list }) => {
  const { hoveredDivision, files } = useContext(CanvasContext);
  const isHovered = list.id === hoveredDivision;
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(null);
  const [listImageUrl, setListImageUrl] = useState(null);
  const [islistHovered, setIslistHovered] = useState(false);
  const [islistFocused, setIslistFocused] = useState(false);
  const [islistActive, setIslistActive] = useState(false);

  const constructGradientString = () => {
    const {
      backgroundGradientImage,
      gradientDirection,
      gradientShape,
      gradientPosition,
      startColor,
      endColor,
      gradientAngle,
      patternLength,
    } = list;

    switch (backgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${gradientDirection || "to right"}, ${
          startColor || "#ff7e5f"
        }, ${endColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${gradientAngle || "45"}deg, ${
          startColor || "#606dbc"
        }, ${endColor || "#465298"} ${patternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"} ${
          patternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const constructHoverGradientString = () => {
    const {
      hoveredbackgroundGradientImage,
      hoveredgradientDirection,
      hoveredgradientShape,
      hoveredgradientPosition,
      hoveredstartColor,
      hoveredendColor,
      hoveredgradientAngle,
      hoveredpatternLength,
    } = list;

    switch (hoveredbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${hoveredgradientDirection || "to right"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${hoveredgradientShape || "circle"} at ${
          hoveredgradientPosition || "center"
        }, ${hoveredstartColor || "#ff7e5f"}, ${hoveredendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${hoveredgradientAngle || "45"}deg, ${
          hoveredstartColor || "#606dbc"
        }, ${hoveredendColor || "#465298"} ${hoveredpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          hoveredgradientShape || "circle"
        } at ${hoveredgradientPosition || "center"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"} ${hoveredpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructFocusedGradientString = () => {
    const {
      focusedbackgroundGradientImage,
      focusedgradientDirection,
      focusedgradientShape,
      focusedgradientPosition,
      focusedstartColor,
      focusedendColor,
      focusedgradientAngle,
      focusedpatternLength,
    } = list;

    switch (focusedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${focusedgradientDirection || "to right"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${focusedgradientShape || "circle"} at ${
          focusedgradientPosition || "center"
        }, ${focusedstartColor || "#ff7e5f"}, ${focusedendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${focusedgradientAngle || "45"}deg, ${
          focusedstartColor || "#606dbc"
        }, ${focusedendColor || "#465298"} ${focusedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          focusedgradientShape || "circle"
        } at ${focusedgradientPosition || "center"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"} ${focusedpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructActivatedGradientString = () => {
    const {
      activatedbackgroundGradientImage,
      activatedgradientDirection,
      activatedgradientShape,
      activatedgradientPosition,
      activatedstartColor,
      activatedendColor,
      activatedgradientAngle,
      activatedpatternLength,
    } = list;

    switch (activatedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${activatedgradientDirection || "to right"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${activatedgradientShape || "circle"} at ${
          activatedgradientPosition || "center"
        }, ${activatedstartColor || "#ff7e5f"}, ${
          activatedendColor || "#feb47b"
        })`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${
          activatedgradientAngle || "45"
        }deg, ${activatedstartColor || "#606dbc"}, ${
          activatedendColor || "#465298"
        } ${activatedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          activatedgradientShape || "circle"
        } at ${activatedgradientPosition || "center"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"} ${
          activatedpatternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };

  useEffect(() => {
    const fetchBackgroundImage = async () => {
      if (list.backgroundImage && list.backgroundImage.startsWith("./")) {
        const imageName = list.backgroundImage.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setBackgroundImageUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setBackgroundImageUrl(list.backgroundImage);
      }
    };

    fetchBackgroundImage();
  }, [list.backgroundImage, files]);

  useEffect(() => {
    const fetchListImage = async () => {
      if (list.listStyleImage && list.listStyleImage.startsWith("./")) {
        const imageName = list.listStyleImage.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setListImageUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setListImageUrl(list.listStyleImage);
      }
    };

    fetchListImage();
  }, [list.listStyleImage, files]);

  const focusedStyles =
    islistFocused && list.pseudoClass === "focus"
      ? {
          width: list.focusedwidth || list.width || "fit-content",
          height: list.focusedheight || list.height || "auto",

          padding: list.focusedpadding || list.padding || "0",
          paddingTop: list.focusedpaddingTop || list.focusedpadding || "0",
          paddingRight: list.focusedpaddingRight || list.focusedpadding || "0",
          paddingBottom:
            list.focusedpaddingBottom || list.focusedpadding || "0",
          paddingLeft: list.focusedpaddingLeft || list.focusedpadding || "0",
          margin: list.focusedmargin || list.margin || "0px",
          marginTop: list.focusedmarginTop || list.focusedmargin || "0px",
          marginRight: list.focusedmarginRight || list.focusedmargin || "0px",
          marginBottom: list.focusedmarginBottom || list.focusedmargin || "0px",
          marginLeft: list.focusedmarginLeft || list.focusedmargin || "0px",

          borderTop:
            list.focusedborderTop ||
            list.focusedborder ||
            list.border ||
            "none",
          borderRight:
            list.focusedborderRight ||
            list.focusedborder ||
            list.border ||
            "none",
          borderBottom:
            list.focusedborderBottom ||
            list.focusedborder ||
            list.border ||
            "none",
          borderLeft:
            list.focusedborderLeft ||
            list.focusedborder ||
            list.border ||
            "none",
          borderSapcing:
            list.focusedborderSpacing || list.borderSpacing || "0px",
          borderCollapse:
            list.focusedborderCollapse || list.borderCollapse || "0px",
          borderRadius: list.focusedborderRadius || list.borderRadius || "0",
          outline: list.focusedoutline || list.outline || "none",

          position: list.focusedposition || list.position || "relative",
          top: list.focusedtop || list.top || "auto",
          right: list.focusedright || list.right || "auto",
          bottom: list.focusedbottom || list.bottom || "auto",
          left: list.focusedleft || list.left || "auto",
          zIndex: list.focusedzIndex || list.zIndex || "auto",
          boxShadow: list.focusedboxShadow || list.boxShadow || "none",
          opacity: list.focusedOpacity || list.opacity || 1,
          color: list.focusedcolor || list.color || "#000000",
          backgroundColor:
            list.focusedbackgroundColor || list.backgroundColor || "#ffffff",
          backgroundImage: (() => {
            if (list.focusedbackgroundImage) {
              if (list.focusedbackgroundImage.startsWith("./")) {
                const imageName = list.focusedbackgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${list.focusedbackgroundImage})`;
            }
            if (list.backgroundImage) {
              if (list.backgroundImage.startsWith("./")) {
                const imageName = list.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${list.backgroundImage})`;
            }
            return (
              constructFocusedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            list.focusedbackgroundPosition ||
            list.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            list.focusedbackgroundSize || list.backgroundSize || "auto",
          backgroundRepeat:
            list.focusedbackgroundRepeat || list.backgroundRepeat || "repeat",
          backgroundAttachment:
            list.focusedbackgroundAttachment ||
            list.backgroundAttachment ||
            "scroll",

          display: list.focuseddisplay || list.display || "block",

          fontFamily: list.focusedfontFamily || list.fontFamily || "inherit",
          fontSize: list.focusedfontSize || list.fontSize || "inherit",
          fontWeight: list.focusedfontWeight || list.fontWeight || "normal",
          fontStyle: list.focusedfontStyle || list.fontStyle || "normal",
          fontVariant: list.focusedfontVariant || list.fontVariant || "normal",
          lineHeight: list.focusedlineHeight || list.lineHeight || "normal",
          textShadow: list.focusedtextShadow || list.textShadow || "none",
          textAlign: list.focusedtextAlign || list.textAlign || "left",
          verticalAlign:
            list.focusedverticalAlign || list.verticalAlign || "baseline",
          textDecoration:
            list.focusedtextDecoration || list.textDecoration || "none",
          textTransform:
            list.focusedtextTransform || list.textTransform || "none",
          letterSpacing:
            list.focusedletterSpacing || list.letterSpacing || "normal",
          wordSpacing: list.focusedwordSpacing || list.wordSpacing || "normal",
          textIndent: list.focusedtextIndent || list.textIndent || "0",
          whiteSpace: list.focusedwhiteSpace || list.whiteSpace || "normal",
          textOverflow: list.focusedtextOverflow || list.textOverflow || "clip",
          direction: list.focuseddirection || list.direction || "ltr",
          unicodeBidi: list.focusedunicodeBidi || list.unicodeBidi || "normal",
          writingMode:
            list.focusedwritingMode || list.writingMode || "horizontal-tb",

          cursor: list.focusedcursor || list.cursor || "default",
          visibility: list.focusedvisibility || "visible",

          transform: list.focusedtransform || list.transform || "none",
          transition: list.focusedtransition || list.transition || "none",
        }
      : {};

  const hoverStyles =
    islistHovered && list.pseudoClass === "hover"
      ? {
          width: list.hoveredwidth || list.width || "fit-content",
          height: list.hoveredheight || list.height || "auto",

          padding: list.hoveredpadding || list.padding || "0",
          paddingTop: list.hoveredpaddingTop || list.hoveredpadding || "0",
          paddingRight: list.hoveredpaddingRight || list.hoveredpadding || "0",
          paddingBottom:
            list.hoveredpaddingBottom || list.hoveredpadding || "0",
          paddingLeft: list.hoveredpaddingLeft || list.hoveredpadding || "0",
          margin: list.hoveredmargin || list.margin || "0px",
          marginTop: list.hoveredmarginTop || list.hoveredmargin || "0px",
          marginRight: list.hoveredmarginRight || list.hoveredmargin || "0px",
          marginBottom: list.hoveredmarginBottom || list.hoveredmargin || "0px",
          marginLeft: list.hoveredmarginLeft || list.hoveredmargin || "0px",

          borderTop:
            list.hoveredborderTop ||
            list.hoveredborder ||
            list.border ||
            "none",
          borderRight:
            list.hoveredborderRight ||
            list.hoveredborder ||
            list.border ||
            "none",
          borderBottom:
            list.hoveredborderBottom ||
            list.hoveredborder ||
            list.border ||
            "none",
          borderLeft:
            list.hoveredborderLeft ||
            list.hoveredborder ||
            list.border ||
            "none",
          borderSapcing:
            list.hoveredborderSpacing || list.borderSpacing || "0px",
          borderCollapse:
            list.hoveredborderCollapse || list.borderCollapse || "0px",
          borderRadius: list.hoveredborderRadius || list.borderRadius || "0",
          outline: list.hoveredoutline || list.outline || "none",

          position: list.hoveredposition || list.position || "relative",
          top: list.hoveredtop || list.top || "auto",
          right: list.hoveredright || list.right || "auto",
          bottom: list.hoveredbottom || list.bottom || "auto",
          left: list.hoveredleft || list.left || "auto",
          zIndex: list.hoveredzIndex || list.zIndex || "auto",
          boxShadow: list.hoveredboxShadow || list.boxShadow || "none",
          opacity: list.hoveredOpacity || list.opacity || 1,

          color: list.hoveredcolor || list.color || "#000000",
          backgroundColor:
            list.hoveredbackgroundColor || list.backgroundColor || "#ffffff",
          backgroundImage: (() => {
            if (list.hoveredbackgroundImage) {
              if (list.hoveredbackgroundImage.startsWith("./")) {
                const imageName = list.hoveredbackgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${list.hoveredbackgroundImage})`;
            }
            if (list.backgroundImage) {
              if (list.backgroundImage.startsWith("./")) {
                const imageName = list.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${list.backgroundImage})`;
            }
            return (
              constructHoverGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            list.hoveredbackgroundPosition ||
            list.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            list.hoveredbackgroundSize || list.backgroundSize || "auto",
          backgroundRepeat:
            list.hoveredbackgroundRepeat || list.backgroundRepeat || "repeat",
          backgroundAttachment:
            list.hoveredbackgroundAttachment ||
            list.backgroundAttachment ||
            "scroll",

          display: list.hovereddisplay || list.display || "block",

          fontFamily: list.hoveredfontFamily || list.fontFamily || "inherit",
          fontSize: list.hoveredfontSize || list.fontSize || "inherit",
          fontWeight: list.hoveredfontWeight || list.fontWeight || "normal",
          fontStyle: list.hoveredfontStyle || list.fontStyle || "normal",
          fontVariant: list.hoveredfontVariant || list.fontVariant || "normal",
          lineHeight: list.hoveredlineHeight || list.lineHeight || "normal",
          textShadow: list.hoveredtextShadow || list.textShadow || "none",
          textAlign: list.hoveredtextAlign || list.textAlign || "left",
          verticalAlign:
            list.hoveredverticalAlign || list.verticalAlign || "baseline",
          textDecoration:
            list.hoveredtextDecoration || list.textDecoration || "none",
          textTransform:
            list.hoveredtextTransform || list.textTransform || "none",
          letterSpacing:
            list.hoveredletterSpacing || list.letterSpacing || "normal",
          wordSpacing: list.hoveredwordSpacing || list.wordSpacing || "normal",
          textIndent: list.hoveredtextIndent || list.textIndent || "0",
          whiteSpace: list.hoveredwhiteSpace || list.whiteSpace || "normal",
          textOverflow: list.hoveredtextOverflow || list.textOverflow || "clip",
          direction: list.hovereddirection || list.direction || "ltr",
          unicodeBidi: list.hoveredunicodeBidi || list.unicodeBidi || "normal",
          writingMode:
            list.hoveredwritingMode || list.writingMode || "horizontal-tb",

          cursor: list.hoveredcursor || list.cursor || "default",
          visibility: list.hoveredvisibility || "visible",

          transform: list.hoveredtransform || list.transform || "none",
          transition: list.hoveredtransition || list.transition || "none",
        }
      : {};

  const activeStyles =
    islistActive && list.pseudoClass === "active"
      ? {
          width: list.activatedwidth || list.width || "fit-content",
          height: list.hoveredheight || list.height || "auto",

          padding: list.activatedpadding || list.padding || "0",
          paddingTop: list.activatedpaddingTop || list.activatedpadding || "0",
          paddingRight:
            list.activatedpaddingRight || list.activatedpadding || "0",
          paddingBottom:
            list.activatedpaddingBottom || list.activatedpadding || "0",
          paddingLeft:
            list.activatedpaddingLeft || list.activatedpadding || "0",
          margin: list.activatedmargin || list.margin || "0px",
          marginTop: list.activatedmarginTop || list.activatedmargin || "0px",
          marginRight:
            list.activatedmarginRight || list.activatedmargin || "0px",
          marginBottom:
            list.activatedmarginBottom || list.activatedmargin || "0px",
          marginLeft: list.activatedmarginLeft || list.activatedmargin || "0px",

          borderTop:
            list.activatedborderTop ||
            list.activatedborder ||
            list.border ||
            "none",
          borderRight:
            list.activatedborderRight ||
            list.activatedborder ||
            list.border ||
            "none",
          borderBottom:
            list.activatedborderBottom ||
            list.activatedborder ||
            list.border ||
            "none",
          borderLeft:
            list.activatedborderLeft ||
            list.activatedborder ||
            list.border ||
            "none",
          borderSapcing:
            list.activatedborderSpacing || list.borderSpacing || "0px",
          borderCollapse:
            list.activatedborderCollapse || list.borderCollapse || "0px",
          borderRadius: list.activatedborderRadius || list.borderRadius || "0",
          outline: list.activatedoutline || list.outline || "none",

          position: list.activatedposition || list.position || "relative",
          top: list.activatedtop || list.top || "auto",
          right: list.activatedright || list.right || "auto",
          bottom: list.activatedbottom || list.bottom || "auto",
          left: list.activatedleft || list.left || "auto",
          zIndex: list.activatedzIndex || list.zIndex || "auto",
          boxShadow: list.activatedboxShadow || list.boxShadow || "none",
          opacity: list.activatedOpacity || list.opacity || 1,
          color: list.activatedcolor || list.color || "#000000",
          backgroundColor:
            list.activatedbackgroundColor || list.backgroundColor || "#ffffff",
          backgroundImage: (() => {
            if (list.activatedbackgroundImage) {
              if (list.activatedbackgroundImage.startsWith("./")) {
                const imageName = list.activatedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${list.activatedbackgroundImage})`;
            }
            if (list.backgroundImage) {
              if (list.backgroundImage.startsWith("./")) {
                const imageName = list.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${list.backgroundImage})`;
            }
            return (
              constructActivatedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            list.activatedbackgroundPosition ||
            list.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            list.activatedbackgroundSize || list.backgroundSize || "auto",
          backgroundRepeat:
            list.activatedbackgroundRepeat || list.backgroundRepeat || "repeat",
          backgroundAttachment:
            list.activatedbackgroundAttachment ||
            list.backgroundAttachment ||
            "scroll",

          display: list.activateddisplay || list.display || "block",

          fontFamily: list.activatedfontFamily || list.fontFamily || "inherit",
          fontSize: list.activatedfontSize || list.fontSize || "inherit",
          fontWeight: list.activatedfontWeight || list.fontWeight || "normal",
          fontStyle: list.activatedfontStyle || list.fontStyle || "normal",
          fontVariant:
            list.activatedfontVariant || list.fontVariant || "normal",
          lineHeight: list.activatedlineHeight || list.lineHeight || "normal",
          textShadow: list.activatedtextShadow || list.textShadow || "none",
          textAlign: list.activatedtextAlign || list.textAlign || "left",
          verticalAlign:
            list.activatedverticalAlign || list.verticalAlign || "baseline",
          textDecoration:
            list.activatedtextDecoration || list.textDecoration || "none",
          textTransform:
            list.activatedtextTransform || list.textTransform || "none",
          letterSpacing:
            list.activatedletterSpacing || list.letterSpacing || "normal",
          wordSpacing:
            list.activatedwordSpacing || list.wordSpacing || "normal",
          textIndent: list.activatedtextIndent || list.textIndent || "0",
          whiteSpace: list.activatedwhiteSpace || list.whiteSpace || "normal",
          textOverflow:
            list.activatedtextOverflow || list.textOverflow || "clip",
          direction: list.activateddirection || list.direction || "ltr",
          unicodeBidi:
            list.activatedunicodeBidi || list.unicodeBidi || "normal",
          writingMode:
            list.activatedwritingMode || list.writingMode || "horizontal-tb",

          cursor: list.activatedcursor || list.cursor || "default",
          visibility: list.activatedvisibility || "visible",

          transform: list.activatedtransform || list.transform || "none",
          transition: list.activatedtransition || list.transition || "none",
        }
      : {};

  const listStyle = {
    listStyleType: list.listStyleType ||  "decimal" || "desc",
    listStyleImage: listImageUrl ? `url(${listImageUrl})` : "none",
    listStylePosition: list.listStylePosition || "inside",

    width: list.width || "fit-content",
    height: list.height || "auto",
    margin: list.margin || "0px",
    marginTop: list.marginTop || list.margin || "0",
    marginRight: list.marginRight || list.margin || "0px",
    marginBottom: list.marginBottom || list.margin || "0",
    marginLeft: list.marginLeft || list.margin || "0px",
    padding: list.padding || "0px",
    paddingTop: list.paddingTop || list.padding || "0",
    paddingRight: list.paddingRight || list.padding || "0",
    paddingBottom: list.paddingBottom || list.padding || "0",
    paddingLeft: list.paddingLeft || list.padding || "0px",

    borderTop: isHovered
      ? "1px dashed #555"
      : list.borderTop || list.border || "none",
    borderRight: isHovered
      ? "1px dashed #555"
      : list.borderRight || list.border || "none",
    borderBottom: isHovered
      ? "1px dashed #555"
      : list.borderBottom || list.border || "none",
    borderLeft: isHovered
      ? "1px dashed #555"
      : list.borderLeft || list.border || "none",

    borderSapcing: list.borderSpacing || "0px",
    borderCollapse: list.borderCollapse || "0px",
    borderRadius: list.borderRadius || "0",
    outline: list.outline || "none",

    position: list.position || "static",
    top: list.top || "auto",
    right: list.right || "auto",
    bottom: list.bottom || "auto",
    left: list.left || "auto",
    zIndex: list.zIndex || "auto",

    display: list.display || "block",
    flexDirection: list.flexDirection || "column",
    flexWrap: list.flexWrap || "nowrap",
    order: list.order || "0",
    flexGrow: list.flexGrow || "0",
    flexShrink: list.flexShrink || "1",
    flexBasis: list.flexBasis || "auto",

    gridTemplateColumns: list.gridTemplateColumns || "none",
    gridTemplateRows: list.gridTemplateRows || "none",
    gridArea: list.gridArea || "auto",
    gridAutoFlow: list.gridAutoFlow || "row",
    gridAutoColumns: list.gridAutoColumns || "auto",
    gridAutoRows: list.gridAutoRows || "auto",
    columnGap: list.columnGap || "0",
    rowGap: list.rowGap || "0",

   //  placeContent: list.placeContent || "normal",
   //  placeItems: list.placeItems || "normal",

    justifyContent: list.justifyContent || "flex-start",
    alignItems: list.alignItems || "stretch",
    alignContent: list.alignContent || "stretch",
    alignSelf: list.alignSelf || "auto",
    justifyItems: list.justifyItems || "stretch",
    justifySelf: list.justifySelf || "auto",

    gap: list.gap || "0",
    visibility: list.visibility || "visible",

    backgroundColor: list.backgroundColor || "#ffffff",
    color: list.color || "#000000",
    backgroundImage: backgroundImageUrl
      ? `url(${backgroundImageUrl})`
      : constructGradientString(),
    backgroundSize: list.backgroundSize || "auto",
    backgroundPosition: list.backgroundPosition || "0% 0%",
    backgroundRepeat: list.backgroundRepeat || "repeat",
    backgroundAttachment: list.backgroundAttachment || "scroll",


    boxShadow: list.boxShadow || "none",
    opacity: list.opacity || "1",
    overflow: list.overflow || "visible",
    overflowX: list.overflowX || "hidden",
    overflowY: list.overflowY || "hidden",

    fontSize: list.fontSize || "inherit",
    fontFamily: list.fontFamily || "inherit",
    fontWeight: list.fontWeight || "normal",
    fontStyle: list.fontStyle || "normal",
    fontVariant: list.fontVariant || "normal",
    lineHeight: list.lineHeight || "normal",
    textAlign: list.textAlign || "left",
    textDecoration: list.textDecoration || "none",
    textTransform: list.textTransform || "none",
    textShadow: list.textShadow || "none",
    verticalAlign: list.verticalAlign || "baseline",
    letterSpacing: list.letterSpacing || "normal",
    wordSpacing: list.wordSpacing || "normal",
    textIndent: list.textIndent || "0",
    whiteSpace: list.whiteSpace || "normal",
    textOverflow: list.textOverflow || "clip",
    direction: list.direction || "ltr",
    unicodeBidi: list.unicodeBidi || "normal",
    writingMode: list.writingMode || "horizontal-tb",

    boxSizing: list.boxSizing || "border-box",
    userSelect: list.userSelect || "auto",
    cursor: list.cursor || "auto",

    transform: list.transform || "none",
    transition: list.transition || "none",

    scale: isHovered ? "1.01" : "1",

    ...hoverStyles,
    ...focusedStyles,
    ...activeStyles,
  };

  const itemsArray = list.items
    ? list.items.split("\n").map((item) => item.trim())
    : [1, 2, 3];

  const ListTag = list.Type === "ol" ? "ol" : "ul";

  return (
    <ListTag
      style={listStyle}
      onMouseEnter={() => setIslistHovered(true)}
      onMouseLeave={() => setIslistHovered(false)}
      onFocus={() => setIslistFocused(true)}
      onBlur={() => setIslistFocused(false)}
      onMouseDown={() => setIslistActive(true)}
      onMouseUp={() => setIslistActive(false)}
    >
      {itemsArray.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ListTag>
  );
};

export default ListComponent;
